import { createSelector } from '@reduxjs/toolkit';
import { pick } from 'lodash';
import type { RootState } from 'src/root/store';

import { ROUTE_PARENT_GUARDIAN_INVITATION } from '@shared/duck/actions';

import { moduleName } from '../constants';

const empty = {} as const;

const moduleSel = (state: RootState) => state[moduleName];
export function routeParamsSel<T>(state: RootState) {
  return createSelector(
    moduleSel,
    state => (state.payload as T) || (empty as T),
  )(state);
}

interface RoutesMap {
  [actionType: string]: RouteOptions;
}

interface RouteOptions {
  path: string;
  titleId: string;
  permission?: string | string[];
  unauthorizedAccess?: boolean;
  standalone?: boolean;
  unauthorizedstandaloneAccess?: boolean;
  Component?: {
    compare: unknown | null;
    displayName: string;
  };
}

export const routesMapSel = (state: RootState) =>
  moduleSel(state)?.routesMap as RoutesMap;

/* Add pages that should be accesible for persons with no organizations */
export const freeAccessRoutesMapSel = createSelector(
  routesMapSel,
  (routesMap: RoutesMap) => pick(routesMap, [ROUTE_PARENT_GUARDIAN_INVITATION]),
);
